import Colors from '@shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListPlanSmallPrice = styled.span`
  color: ${Colors['green']};
  font-family: ${Fonts['regular']};
  font-size: ${42 * Screen.widthRatio}px;
  line-height: ${49 * Screen.widthRatio}px;
`;

export default ChannelListPlanSmallPrice;
